import {SalesDespatchNoteReport, SellingCompanyReport} from "tms-lib";

export interface SalesManifestReport {
  id: string;
  manifestNo: number;
  dateCreated: Date;
  supplierKey: string;
  supplierName: string;
  supplierEmail: string;
  supplierAddressMultiLine: string;
  createdBy: string;
  comments: string;
  grossQuantity: number;
  nettQuantity: number;
  noOfItems: number;
  goodsValue: number;
  currencySymbol: string;
  unitOfMeasure: string;

  sellingCompany: SellingCompanyReport;
  salesDespatchNotes: SalesDespatchNoteReport[];
}
